// Script para crear categorías con estructura completa usando Firebase SDK del navegador
export {};

(window as any).createCompleteCategoriesStructure = async function() {
  console.log('🚀 Creando estructura completa de categorías...');
  
  try {
    // Verificar que Firebase esté disponible
    if (!(window as any).auth) {
      throw new Error('Firebase no está disponible');
    }
    
    const { db, collection, doc, setDoc, serverTimestamp } = (window as any).auth;
    
    // Obtener el ID del usuario actual
    const userId = (window as any).auth.auth.currentUser?.uid;
    if (!userId) {
      throw new Error('Usuario no autenticado');
    }

    console.log(`👤 Usuario: ${userId}`);

    // Definir todas las categorías con sus campos específicos
    const categories = {
      'REMERA': {
        name: 'REMERA',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Manga corta', 'Manga larga', 'Musculosa', 'Crop Top', 'Polo', 'Térmica'],
            required: true
          },
          cuello: {
            type: 'select',
            options: ['Redondo', 'En V', 'Polo', 'Escote Bote', 'Cuello alto'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Urbano', 'Deportivo', 'Básico', 'Oversize'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'CAMPERA': {
        name: 'CAMPERA',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Abrigo grueso', 'Deportiva', 'Rompeviento', 'Jean', 'Cuero', 'Inflable', 'Bomber', 'Parka', 'Impermeable'],
            required: true
          },
          material: {
            type: 'select',
            options: ['Algodón', 'Poliéster', 'Cuero', 'Eco-Cuero', 'Denim', 'Nylon', 'Lana', 'Softshell', 'Gabardina'],
            required: true
          },
          tipoCierre: {
            type: 'select',
            options: ['Cierre', 'Abotonado'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Urbano', 'Deportivo', 'Formal', 'Outdoor'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'PANTALÓN': {
        name: 'PANTALÓN',
        fields: {
          talle: {
            type: 'select',
            options: ['26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Jean', 'Jogger', 'Babucha', 'Sastrero', 'Deportivo', 'Cargo', 'Chupín', 'Oxford', 'Recto', 'Acampanado'],
            required: true
          },
          corte: {
            type: 'select',
            options: ['Regular Fit', 'Slim Fit', 'Wide Leg', 'Recto', 'Chupín', 'Flare'],
            required: true
          },
          tiro: {
            type: 'select',
            options: ['Alto', 'Medio', 'Bajo'],
            required: true
          },
          largo: {
            type: 'select',
            options: ['Largo', 'Corto', 'Short', 'Bermuda', '7/8', '3/4'],
            required: true
          },
          material: {
            type: 'select',
            options: ['Denim', 'Algodón', 'Gabardina', 'Poliéster', 'Lino', 'Frisa', 'Elastano'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Formal', 'Urbano', 'Deportivo'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      }
    };

    // Campos globales para todos los productos
    const globalFields = {
      sku: {
        type: 'text',
        generated: true,
        required: true
      },
      stock: {
        type: 'number',
        format: 'thousands',
        required: true
      },
      precioCompra: {
        type: 'currency',
        symbol: '$',
        format: 'thousands',
        required: true
      },
      precioVenta: {
        type: 'currency',
        symbol: '$',
        format: 'thousands',
        required: true
      },
      fechaIngreso: {
        type: 'date',
        format: 'DD/MM/AA',
        required: true
      },
      marca: {
        type: 'select',
        searchable: true,
        required: true
      },
      proveedor: {
        type: 'select',
        searchable: true,
        required: true
      },
      genero: {
        type: 'select',
        options: ['Hombre', 'Mujer', 'Niños', 'Niñas', 'Unisex'],
        multiple: true,
        required: true
      },
      temporada: {
        type: 'select',
        options: ['Verano', 'Otoño', 'Invierno', 'Primavera', 'Atemporal'],
        required: true
      }
    };

    // Crear cada categoría
    for (const [categoryName, categoryData] of Object.entries(categories)) {
      console.log(`📂 Creando categoría: ${categoryName}`);
      
      // Agregar campos globales a cada categoría
      const completeCategoryData = {
        ...categoryData,
        fields: {
          ...categoryData.fields,
          ...globalFields
        },
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };
      
      // Crear documento principal de la categoría
      const categoryRef = doc(db, 'users', userId, 'categories', categoryName);
      await setDoc(categoryRef, completeCategoryData);
      
      // Crear documento placeholder en /stock/ para mantener la estructura
      const stockRef = doc(db, 'users', userId, 'categories', categoryName, 'stock', '.placeholder');
      await setDoc(stockRef, {
        _placeholder: true,
        message: 'Esta carpeta contiene los productos de la categoría',
        createdAt: serverTimestamp()
      });
      
      console.log(`✅ Categoría "${categoryName}" creada con estructura completa`);
    }
    
    console.log('🎉 Estructura completa de categorías creada exitosamente');
    console.log('📋 Estructura:');
    console.log('   - Colección: users/{userId}/categories/');
    console.log('   - Documentos: users/{userId}/categories/{CATEGORY_NAME}');
    console.log('   - Stock: users/{userId}/categories/{CATEGORY_NAME}/stock/');
    console.log('   - Productos: users/{userId}/categories/{CATEGORY_NAME}/stock/{SKU}');
    
    return {
      success: true,
      message: 'Estructura completa de categorías creada exitosamente',
      categories: Object.keys(categories)
    };
    
  } catch (error) {
    console.error('❌ Error creando estructura:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : error
    };
  }
};

console.log('🔧 Script de creación completa cargado');
console.log('💡 Usa: window.createCompleteCategoriesStructure()');
